import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  rootDesktop: {
    display: 'grid',
    gridAutoFlow: 'column',
    alignItems: 'center',
  },
  userName: {
    fontWeight: 500,
    fontSize: '18px',
    lineHeight: '23px',
    color: '#1B1A1A',
  },
  userEmail: {
    fontWeight: 400,
    fontSize: '14px',
    color: '#bcbcbc',
  },
  logOut: {
    cursor: 'pointer',
    marginLeft: '10px',
  },
  userImg: {
    width: '35px',
    height: '35px',
    borderRadius: '50%',
    background: '#dfdfdf',
    marginRight: '5px',
    objectFit: 'cover',
  },
  userProfile: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
  },
  mobileHeaderRow: {
    display: 'grid',
    gridAutoFlow: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gridGap: '15px',
  },
}));
